import { combineReducers } from "@reduxjs/toolkit";


import { StoreAction } from "../utils/actions";
import authReducer from "./reducers/auth.reducer";
import weatherReducer from "./reducers/weather.reducer";
import eventReducer from "./reducers/events.reducer";
import notificationReducer from "./reducers/notification.reducer";
import masterDataReducer from "./reducers/master.reducer";
import problemIdentificationDataReducer from "./reducers/Stages/projectinitiation/ProblemIdentification.reducer";

const appReducer = combineReducers({
    authReducer: authReducer,
    notificationReducer: notificationReducer,
    eventReducer: eventReducer,
    weatherReducer: weatherReducer,
    masterDataReducer: masterDataReducer,
    problemIdentificationDataReducer: problemIdentificationDataReducer
});

const rootReducer = (
    state: ReturnType<typeof appReducer> | undefined,
    action: any
) => {
    if (action.type === StoreAction.CLEAR_REDUX) {
        state = undefined; // 🔥 clears entire Redux
    }
    return appReducer(state, action);
};

export default rootReducer;